import { Box } from '@mui/material';

interface LogoProps {
  width?: number | string;
  height?: number | string;
  useWhiteLogo?: boolean;
}

const Logo = ({ width = 'auto', height = 40, useWhiteLogo = false }: LogoProps) => {
  return (
    <Box
      component="img"
      src={useWhiteLogo ? '/logo_white.png' : '/logo.png'}
      alt="zube Logo"
      sx={{
        width,
        height,
      }}
    />
  );
};

export default Logo; 